/**
 * Blockquote block JS.
 * 
 * - blockquoteNoImage: Adds negative margin to the container if the blockquote block has no image.
 * 
 * @package lycee-francais
 */
function blockquoteNoImage(){
	const noImage = document.querySelectorAll('[data-name="no-image"]');

	if ( noImage.length > 0 ) {
		noImage.forEach(image => {			
			if (
				image.closest('.container')?.parentElement?.dataset?.prevBlock !== "process" &&
				image.closest('.container')?.parentElement?.dataset?.prevBlock !== "text-and-media"
			) {
				image.closest('.container').classList.add('!-mt-80', 'md:!-mt-70', 'lg:-mt-30');
			}
		});
	}
}

function blockquote(){
	blockquoteNoImage();
}
export default blockquote;
